export const HCE_INFORME_MODELO = `
OSPEDYC
Obra Social del Personal de Entidades Deportivas y Civiles
Departamento de Imágenes
Ecografía y Doppler

NOMBRE: [__Nombre__]
NRO BENEFICIARIO: [__nro_afi__]

FECHA: [__fecha__]

NOMBRE ESTUDIO

INFORME.....

NOMBRE ESPECIALISTA
Especialista en diagnóstico por imágenes
MP......  MN...... 
`;
